import { MenuItem, Separator } from 'react-aria-components'

import { css, cx } from '@portal/styled-system/css'

import { getAssetUrl } from '@/shared/lib/cdn'
import { useI18n } from '@/shared/lib/i18n'
import { DropdownMenu } from '@/widgets/layout/navbar/ui/dropdown-menu'

import {
    AboutPageLink,
    BuildVersionInfo,
    KnowledgeLink,
    LangButton,
    LegalLinks,
    NewsButton,
    SupportContactButton,
} from '../ui'
import { navbar, navbarMenu } from '../ui/styles/recipe'

export function NavbarHome() {
    const classes = navbar({ isFixed: true })

    return (
        <div className={classes.root}>
            <div className={css({ display: 'flex', alignItems: 'center' })}>
                <div className={css({ height: '[28px]', _hover: { animation: '[spin 1s linear infinite reverse]' } })}>
                    <img
                        src={getAssetUrl('/assets/taongaSwirl.svg')}
                        height="28"
                        width="28"
                        alt=""
                        className={css({ margin: 'auto' })}
                        draggable="false"
                    />
                </div>
                <ul className={cx(classes.list, css({ marginLeft: '2' }))}>
                    <NavMenuDropdown />

                    <AboutPageLink />
                    <NewsButton />
                    <SupportContactButton />
                    <KnowledgeLink />
                </ul>
            </div>

            <ul className={cx(classes.list, css({ marginRight: '1' }))}>
                <BuildVersionInfo />
                <LangButton />
            </ul>
        </div>
    )
}

function NavMenuDropdown() {
    const { i18n } = useI18n()
    const classes = navbarMenu()

    return (
        <li className={css({ display: { lg: 'none' } })}>
            <DropdownMenu>
                <AboutPageLink variant="dropdown" />
                <NewsButton variant="dropdown" />
                <SupportContactButton variant="dropdown" />
                <KnowledgeLink variant="dropdown" />

                <Separator className={classes.separator} />

                <LegalLinks />

                <Separator className={classes.separator} />

                <MenuItem
                    isDisabled
                    className={css({
                        paddingX: '2',
                        marginBottom: '1',
                        fontSize: '[12px]',
                    })}
                >
                    {i18n.PORTAL_COPYRIGHT_FULL}
                </MenuItem>
            </DropdownMenu>
        </li>
    )
}
